module.exports = __webpack_public_path__ + "img/img_icp@2x.933be0f9.png";